module.exports = __webpack_public_path__ + "img/utility.2ea490af.svg";